/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
class ErrorHandler {
    constructor() {
        this.logError = this.logError.bind(this);
    }

    logError(err) {
        console.error('Error', err);
    }
}

module.exports = ErrorHandler;
